import {Box, Button, HStack, Image, Img, Link, Spinner, Text} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {LinkedinSvg, TwitterSvg} from '../../../assets';
import axios from "axios";
import AmazonMusic from '../../../assets/images/amazon-music-logo.png';
import ApplePodcasts from '../../../assets/images/apple-podcasts-logo-sm.png';
import SoundCloud from '../../../assets/images/soundcloud-logo-sm.png';
import Spotify from '../../../assets/images/Spotify_logo_with_text.png';
import Stitcher from '../../../assets/images/stitcher-logo.png';
import Podchaser from '../../../assets/images/podchaser-startup-logo.png';
import Pocketcasts from '../../../assets/images/Pocket_Casts_logo.png';

const Post = ({podcastDetail}) => {
    const [podcastServices, setPodcastServices] = useState(undefined)
    useEffect(() => {
        const abortController = new AbortController();
        const fetchPodcastsData = async () => {
            let podcast = "running-through-walls";
            console.log("podcastDetail",  podcastDetail)
            if(podcastDetail?.category_slugs.indexOf("the-outer-join") >= 0) {
                podcast = "the-outer-join";
            }

            const serviceData = await axios.get(`/wp-admin/admin-ajax.php?action=get_podcast_information&podcast=${podcast}`, {signal: abortController.signal}).then(resp => {
                return resp.data;
            });
            setPodcastServices(serviceData)
        }
        fetchPodcastsData()
        return () => {
            abortController.abort();
        }
    }, [podcastDetail])
    if (!podcastDetail) {
        return (
            <Box my={20} width="100%" textAlign="center">
                <Spinner color='blue.600' size='xl'/>
            </Box>
        )
    }
    const url = window?.location?.href
    return (
        <Box maxW={'960px'}>
            <Box mb={'13px'}>
                <Text
                    as={'header'}
                    fontSize={{base: '32px', md: '48px'}}
                    lineHeight={{base: '32.5px', md: '52.8px'}}
                    letterSpacing={'-2px'}
                    textColor={'#333333'}
                    fontWeight={'semibold'}
                    dangerouslySetInnerHTML={{__html: podcastDetail?.title?.rendered}}
                >

                </Text>
            </Box>
            {podcastDetail?.acf.subtitle && (
                <Box mb={'74px'}>
                    <Text as={'p'} fontSize={'24px'} lineHeight={'31.2px'} textColor={'#333333'}>
                        {podcastDetail?.acf.subtitle}
                    </Text>
                </Box>
            )}
            <Box display={'flex'} alignItems={'center'} mb={'40px'} maxW={'100%'}>
                {podcastDetail?.coauthors?.map((a) => {
                    const children = () => {
                        return (
                            <>
                                {a?.image_url &&
                                    <Image
                                        w={'60px'}
                                        h={'60px'}
                                        src={a?.image_url}
                                        borderRadius={'full'}
                                        mr={'20px'}
                                    />
                                }
                                <Text
                                    as={'span'}
                                    fontWeight={'semibold'}
                                    fontSize={'16px'}
                                    lineHeight={'20px'}
                                    textColor={'brand.700'}
                                    paddingRight={'20px'}
                                >
                                    {a.name}
                                </Text>
                            </>
                        )
                    }
                    if (a?.link_url) {
                        return (
                            <Link href={a?.link_url} display="flex" alignItems="center"
                                  _hover={{textDecoration: 'none'}} _focus={{boxShadow: 'none'}} mr={2}>
                                {children()}
                            </Link>
                        )
                    }
                    return children()
                })}
            </Box>

            <HStack spacing={'4px'} display={'flex'} alignItems={'center'} maxW={'100%'}
                    mb={{base: '40px', md: '80px'}}>
                <Text as="span">Share</Text>
                <a href={`http://www.twitter.com/share?url=${url}&text=${encodeURI(podcastDetail?.title?.raw)}`} target={'_blank'}
                   rel="noopener noreferrer">
                    <Button
                        size={'xs'}
                        variant={'solid'}
                        bgColor={'transparent'}
                        iconSpacing={0}
                        borderRadius={'full'}
                    >
                        <TwitterSvg/>
                    </Button>
                </a>
                <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} target={'_blank'}
                   rel="noopener noreferrer">
                    <Button
                        size={'xs'}
                        variant={'solid'}
                        bgColor={'transparent'}
                        iconSpacing={0}
                        borderRadius={'full'}
                    >
                        <LinkedinSvg/>
                    </Button>
                </a>
            </HStack>
            {podcastDetail?.acf?.header_image &&
                <Box mb={'70px'}>
                    <Image
                        maxH={'530px'}
                        w={'full'}
                        objectFit={'cover'}
                        alt={'poster'}
                        src={podcastDetail?.acf?.header_image}
                        mb={'20px'}
                    />
                </Box>
            }
            <Text as={'p'} fontSize={'lg'} lineHeight={'25.2px'}
                  sx={{
                      '& p': {
                          mt: '1.25rem !important',
                      },
                      '& span': {
                          textColor: `brand.700`,
                      }
                  }}
                  className="venrock-article-body"
            >
                <div mb={'20px'} mt={'20px'} dangerouslySetInnerHTML={{__html: podcastDetail?.content?.rendered}}/>
            </Text>

            {podcastDetail?.acf.play_url ? (
                <Box
                    as={'a'}
                    display={'flex'}
                    target={'_blank'}
                    rel="noopener noreferrer"
                    href={podcastDetail?.acf.play_url}
                    mb={'80px'}
                >
                    <Button size={'lg'} isActive mt={5}>
                        Listen here
                    </Button>
                </Box>
            ) : (
                <Box mt={'20px'} mb={'20px'}>
                    <Box mt={'auto'} width={'100%'}>
                        <div dangerouslySetInnerHTML={{
                            __html: podcastDetail?.acf?.podcast_player,
                        }}></div>
                    </Box>
                </Box>
            )}

            <Box mb={'80px'}>
                <Box
                    borderY={'1px solid rgba(0, 0, 0, 0.1)'}
                    display={'flex'}
                    alignItems={'center'}
                    py={'2rem'}
                >
                    <Text mr={'1rem'} fontSize={'20px'} lineHeight={'31.2px'} textColor={'#333333'}>
                        Subscribe:
                    </Text>
                    <HStack spacing={4} justify={'space-between'}>
                        {podcastServices?.amazon_url &&
                            <a target={'_blank'} href={podcastServices?.amazon_url} rel="noopener noreferrer">
                                <Img
                                    h={'25px'}
                                    w={'auto'}
                                    objectFit={'contain'}
                                    src={AmazonMusic}
                                />
                            </a>
                        }
                        {podcastServices?.apple_url &&
                            <a target={'_blank'} href={podcastServices?.apple_url} rel="noopener noreferrer">
                                <Img
                                    h={'25px'}
                                    w={'auto'}
                                    objectFit={'contain'}
                                    src={ApplePodcasts}
                                />
                            </a>
                        }
                        {/* <Img h={'25px'} w={'auto'} src={podcastServices.player_block} /> */}
                        {podcastServices?.soundcloud_url &&
                            <a target={'_blank'} href={podcastServices?.soundcloud_url} rel="noopener noreferrer">
                                <Img
                                    h={'25px'}
                                    w={'auto'}
                                    objectFit={'contain'}
                                    src={SoundCloud}
                                />
                            </a>
                        }
                        {podcastServices?.spotify_url &&
                            <a target={'_blank'} href={podcastServices?.spotify_url} rel="noopener noreferrer">
                                <Img
                                    h={'25px'}
                                    w={'auto'}
                                    objectFit={'contain'}
                                    src={Spotify}
                                />
                            </a>
                        }
                        {podcastServices?.stitcher_url &&
                            <a target={'_blank'} href={podcastServices?.stitcher_url} rel="noopener noreferrer">
                                <Img
                                    h={'25px'}
                                    w={'auto'}
                                    objectFit={'contain'}
                                    src={Stitcher}
                                />
                            </a>
                        }
                        {podcastServices?.podchaser_url &&
                            <a target={'_blank'} href={podcastServices?.podchaser_url} rel="noopener noreferrer">
                                <Img
                                    h={'25px'}
                                    w={'auto'}
                                    objectFit={'contain'}
                                    src={Podchaser}
                                />
                            </a>
                        }
                        {podcastServices?.pocketcasts_url &&
                            <a target={'_blank'} href={podcastServices?.pocketcasts_url} rel="noopener noreferrer">
                                <Img
                                    h={'25px'}
                                    w={'auto'}
                                    objectFit={'contain'}
                                    src={Pocketcasts}
                                />
                            </a>
                        }
                    </HStack>
                </Box>
            </Box>
            {podcastDetail?.acf.full_transcript ? (
            <Text as={'p'} fontSize={'lg'} lineHeight={'25.2px'}
                  sx={{
                      '& p': {
                          mt: '1.25rem !important',
                      },
                      '& span': {
                          textColor: `brand.700`,
                      }
                  }}
                  className="venrock-article-body"
            >
                <div mb={'20px'} mt={'20px'} dangerouslySetInnerHTML={{__html: podcastDetail?.acf?.full_transcript}}/>
            </Text>) : ""}
            {/*<Box mb={'10px'} maxW={'623px'}>*/}
            {/*    <Text*/}
            {/*        as={'header'}*/}
            {/*        fontSize={{base: '24px', md: '32px'}}*/}
            {/*        lineHeight={{base: '28.5px', md: '42.8px'}}*/}
            {/*        letterSpacing={'-2px'}*/}
            {/*        textColor={'#333333'}*/}
            {/*    >*/}
            {/*        <Text as={'span'} textColor={'brand.700'}>*/}
            {/*            Want more?&nbsp;*/}
            {/*        </Text>*/}
            {/*        Here's the latest on <br/><span style={{fontStyle: 'italic'}}>Running Through Walls</span>.*/}
            {/*    </Text>*/}
            {/*</Box>*/}

            {/*<div dangerouslySetInnerHTML={{__html: podcastServices?.player_block}}/>*/}
        </Box>
    )
        ;
};

export default Post;
